import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import Grid from '@mui/material/Grid'

import { CardSkeleton } from './CardSkeleton'
import { useAppSelector } from 'redux/Hook'
import { CardContainer } from './CardContainer'
import TagSearchAnalyzer from '../TagSearchAnalyzer'
import BulkSelectionMessage from '../BulkSelectionMessage'

const Wrapper = styled(Box)`
  position: relative;
  height: calc(100% - 10rem);
  width: 100%;
`

const TextAnalysisContent = () => {
  const {
    total,
    allContributions: { fetching },
    contributions: { loading },
  } = useAppSelector((state) => state.textAnalysis)

  return (
    <Wrapper data-testid="ta-content">
      <Grid container>
        <TagSearchAnalyzer />
        <BulkSelectionMessage />
        {loading || (fetching && total === 0) ? (
          <CardSkeleton count={10} />
        ) : (
          <CardContainer />
        )}
      </Grid>
    </Wrapper>
  )
}

export default React.memo(TextAnalysisContent)
